import { Routes } from '@angular/router';
import { authGuard } from './core/http/auth.guard';
import { ErrorComponent } from './core/error/error.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { UpdateHistoryComponent } from './pages/update-history/update-history.component';
import { FlowDefinitionComponent } from './pages/flow-definition/flow-definition.component';
import { FlowDefinitionListComponent } from './pages/flow-definition-list/flow-definition-list.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { FlowInboxDirectoryComponent } from './pages/flow-inbox-directory/flow-inbox-directory.component';
import { Enums } from './shared/enums';
import { HomeComponent } from './pages/home/home.component';

const canLeaveFlowDefinitionPageGuard = (component: FlowDefinitionComponent) => {
    return component.ngOnDestroy();
};

// data: array vazio para aceitar todos os perfis do AC
export const routes: Routes = [
    {
        path: Enums.PagesPaths.LandingPage.slice(1),
        component: LandingPageComponent,
        canActivate: [authGuard],
        data: { profiles: [], isLandingPage: true }
    },
    {
        path: Enums.PagesPaths.UpdateHistory.slice(1),
        component: UpdateHistoryComponent,
        canActivate: [authGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: Enums.PagesPaths.Home.slice(1),
        component: HomeComponent,
        canActivate: [authGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: Enums.PagesPaths.FlowDefinitionList.slice(1),
        component: FlowDefinitionListComponent,
        canActivate: [authGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: `${Enums.PagesPaths.FlowDefinitionList.slice(1)}/:id`,
        component: FlowDefinitionListComponent,
        canActivate: [authGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: `${Enums.PagesPaths.FlowInboxDirectory.slice(1)}/:id`,
        component: FlowInboxDirectoryComponent,
        canActivate: [authGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: Enums.PagesPaths.Dashboard.slice(1),
        component: DashboardComponent,
        canActivate: [authGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: Enums.PagesPaths.FlowDefinition.slice(1),
        component: FlowDefinitionComponent,
        canActivate: [authGuard],
        canDeactivate: [canLeaveFlowDefinitionPageGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: `${Enums.PagesPaths.FlowDefinition.slice(1)}/:id`,
        component: FlowDefinitionComponent,
        canActivate: [authGuard],
        canDeactivate: [canLeaveFlowDefinitionPageGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: `${Enums.PagesPaths.FlowDefinition.slice(1)}/:id/:version`,
        component: FlowDefinitionComponent,
        canActivate: [authGuard],
        canDeactivate: [canLeaveFlowDefinitionPageGuard],
        data: { profiles: [Enums.Profiles.Administrator, Enums.Profiles.AdminAll] }
    },
    {
        path: Enums.PagesPaths.Error.slice(1),
        component: ErrorComponent,
        canActivate: [authGuard],
        data: { profiles: [Enums.Profiles.ErrorPage] }
    },
    {
        path: Enums.PagesPaths.AccessDenied.slice(1),
        component: AccessDeniedComponent,
        canActivate: [authGuard],
        data: { profiles: [] }
    },
    {
        path: '**',
        redirectTo: ''
    }
];
